import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";


function Logout() {

    const { logOut } = useUserAuth();
    const navigate = useNavigate();

    useEffect(() => {

        try {
            logOut();
            navigate("/login");

        }
        catch (err) {
            console.log(err);
        }
    }, [])


    return (
        <div>
            <h1>Logging Out ... </h1>

        </div>

    )
}

export default Logout